import React from 'react';
import { clsx } from 'clsx';
import { EditProps, Edit } from 'react-admin';

import { Forbidden } from '@components';
import { useEditProps, useRbacEdit, useRbacView } from '@hooks';
import { ProductForm } from '@pages/product/ProductForm';
import cls from '../ProductForm/ProductForm.module.css';

const Title = ({ record }: {record?: any}) =>
  record ? (<span>Product: {record.nameMx}</span>) : null;

export const ProductEdit = (props: EditProps) => {
  const editProps = useEditProps();
  const rbacView = useRbacView();
  const rbacEdit = useRbacEdit();

  if (!rbacView) {
    return <Forbidden />;
  }

  return (
    <Edit
      {...props}
      title={<Title />}
      {...editProps}
      className={clsx(cls.page, 'details-page-wrapper')}>
      <ProductForm editPage canEdit={rbacEdit} />
    </Edit>
  );
};
